/* eslint-disable @typescript-eslint/no-explicit-any */
import { axiosClient, headersCommon } from '../helpers/axiosClient';
import commonFetch, { FetchResponse } from '../helpers/commoFetch';

export const ChatServices = {
  controllerCreateConversation: new AbortController(),
  // Create a new chat
  createConversation: (message: any) => {
    const url = 'api/chat/create';
    return commonFetch(
      url,
      {
        method: 'POST',
        customHeaders: { ...headersCommon },
        body: message,
        signal: ChatServices.controllerCreateConversation.signal
      },
      true
    );
  },

  // Send a message
  sendMessage: <T>(message: {
    content: any;
    id: string;
  }): Promise<FetchResponse<T>> => {
    const url = `api/chat/conversation/${message.id}`;
    return axiosClient.post(url, { ...message?.content });
  },

  controllerSendMessageStream: new AbortController(),
  // Send a message with streaming (use fetch because axios not supports streaming)
  sendMessageStream: <T>(message: {
    content: any;
    id: string;
    signal?: AbortSignal
  }): Promise<FetchResponse<T>> => {
    const url = `api/chat/chat-stream/${message.id}`;
    return commonFetch(
      url,
      {
        method: 'POST',
        customHeaders: { ...headersCommon },
        body: message?.content,
        signal: ChatServices.controllerSendMessageStream.signal
      },
      true
    );
  },

  // Delete a conversation
  deleteConversation: (id: string) => {
    const url = `api/conversation/${id}`;
    return axiosClient.delete(url);
  },

  // Get all conversations
  getConversations: () => {
    const url = 'api/conversation';
    return axiosClient.get(url);
  },

  // Get a conversation
  getConversationById: (id: string) => {
    const url = `api/conversation/${id}`;
    return axiosClient.get(url);
  },


  // Upldate name a conversation
  updateTitleConversationById: (id: string, title: string) => {
    const url = `api/conversation/edit/${id}`;
    return axiosClient.put(url, { title });
  },

  controllerCreateConversationWithTemplate: new AbortController(),

  // Create a conversation with share template
  createConversationWithTemplate: <T>(message: {
    content: any;
    id: string | number;
  }): Promise<FetchResponse<T>> => {
    const url = `api/chat/create-with-template/${message.id}`;
    return commonFetch(
      url,
      {
        method: 'POST',
        customHeaders: { ...headersCommon },
        body: message?.content,
        signal: ChatServices.controllerCreateConversationWithTemplate.signal,
      },
      true
    );
  },

  // Create a conversation with template
  createConversationWithUserTemplate: <T>(message: {
    content: any;
    id: string | number;
  }): Promise<FetchResponse<T>> => {
    const url = `api/chat/create-with-user-template/${message.id}`;
    return commonFetch(
      url,
      {
        method: 'POST',
        customHeaders: { ...headersCommon },
        body: message?.content,
      },
      true
    );
  },

  createConversationWithFile: (data: {
    fileIds: number[],
    conversationId?: string,
   }) => {
    const url = 'api/chat/create-with-file';
    const dataPost: any = {
      dataTemplate: null,
      external: null,
      history: [],
      question: 'File uploaded',
      ...data,
    }
    return axiosClient.post(url, dataPost);
  },

  chatWithFile: (data: {
    fileIds: number[],
   }) => {
    const url = 'api/chat/create-with-file';
    return axiosClient.post(url, {
      dataTemplate: null,
      external: null,
      history: [],
      question: 'File uploaded',
      ...data,
    });
  },

  abortConversationAll: () => {
    ChatServices.controllerSendMessageStream.abort();
    ChatServices.controllerCreateConversation.abort();
    ChatServices.controllerCreateConversationWithTemplate.abort();
    ChatServices.controllerSendMessageStream = new AbortController();
    ChatServices.controllerCreateConversation = new AbortController();
    ChatServices.controllerCreateConversationWithTemplate = new AbortController();
  }
};
